import React from "react";
import * as Path from "routes/Path/index";

export const mainModule = [
  /**************DASHBOARD*********/
  {
    url: Path.dashboard,
    model_name: "dashboard",
    name: "Dashboard",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <path
          d="M7.83279 6.6882H1.58279C0.778652 6.6882 0.124512 6.03406 0.124512 5.22977V1.47977C0.124512 0.675625 0.778652 0.0214844 1.58279 0.0214844H7.83279C8.63709 0.0214844 9.29123 0.675625 9.29123 1.47977V5.22977C9.29123 6.03406 8.63709 6.6882 7.83279 6.6882ZM1.58279 1.27148C1.52757 1.27153 1.47461 1.29348 1.43556 1.33253C1.39651 1.37159 1.37455 1.42454 1.37451 1.47977V5.22977C1.37452 5.28502 1.39646 5.338 1.43552 5.37709C1.47457 5.41617 1.52754 5.43815 1.58279 5.4382H7.83279C7.88807 5.43818 7.94107 5.41622 7.98016 5.37713C8.01924 5.33805 8.04121 5.28504 8.04123 5.22977V1.47977C8.04118 1.42451 8.0192 1.37154 7.98011 1.33249C7.94103 1.29344 7.88804 1.27149 7.83279 1.27148H1.58279ZM7.83279 20.0215H1.58279C0.778652 20.0215 0.124512 19.3673 0.124512 18.5632V9.8132C0.124512 9.00891 0.778652 8.35477 1.58279 8.35477H7.83279C8.63709 8.35477 9.29123 9.00891 9.29123 9.8132V18.5632C9.29123 19.3673 8.63709 20.0215 7.83279 20.0215ZM1.58279 9.60477C1.52754 9.60482 1.47457 9.6268 1.43552 9.66588C1.39646 9.70497 1.37452 9.75795 1.37451 9.8132V18.5632C1.37455 18.6184 1.39651 18.6714 1.43556 18.7104C1.47461 18.7495 1.52757 18.7714 1.58279 18.7715H7.83279C7.88804 18.7715 7.94103 18.7495 7.98011 18.7105C8.0192 18.6714 8.04118 18.6185 8.04123 18.5632V9.8132C8.04121 9.75793 8.01924 9.70492 7.98016 9.66584C7.94107 9.62675 7.88807 9.60479 7.83279 9.60477H1.58279ZM18.6662 20.0215H12.4162C11.6119 20.0215 10.9578 19.3673 10.9578 18.5632V14.8132C10.9578 14.0089 11.6119 13.3548 12.4162 13.3548H18.6662C19.4704 13.3548 20.1245 14.0089 20.1245 14.8132V18.5632C20.1245 19.3673 19.4704 20.0215 18.6662 20.0215ZM12.4162 14.6048C12.361 14.6048 12.308 14.6268 12.2689 14.6658C12.2298 14.7049 12.2078 14.7579 12.2078 14.8132V18.5632C12.2078 18.6185 12.2298 18.6714 12.2689 18.7105C12.308 18.7495 12.361 18.7715 12.4162 18.7715H18.6662C18.7215 18.7714 18.7744 18.7495 18.8135 18.7104C18.8525 18.6714 18.8745 18.6184 18.8745 18.5632V14.8132C18.8745 14.758 18.8526 14.705 18.8135 14.6659C18.7745 14.6268 18.7215 14.6048 18.6662 14.6048H12.4162ZM18.6662 11.6882H12.4162C11.6119 11.6882 10.9578 11.0341 10.9578 10.2298V1.47977C10.9578 0.675625 11.6119 0.0214844 12.4162 0.0214844H18.6662C19.4704 0.0214844 20.1245 0.675625 20.1245 1.47977V10.2298C20.1245 11.0341 19.4704 11.6882 18.6662 11.6882ZM12.4162 1.27148C12.361 1.27149 12.308 1.29344 12.2689 1.33249C12.2298 1.37154 12.2078 1.42451 12.2078 1.47977V10.2298C12.2078 10.285 12.2298 10.338 12.2689 10.3771C12.308 10.4162 12.361 10.4382 12.4162 10.4382H18.6662C18.7215 10.4382 18.7745 10.4162 18.8135 10.3771C18.8526 10.338 18.8745 10.285 18.8745 10.2298V1.47977C18.8745 1.42454 18.8525 1.37159 18.8135 1.33253C18.7744 1.29348 18.7215 1.27153 18.6662 1.27148H12.4162Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },

  /**************Doctor*********/
  {
    url: Path.doctor,
    model_name: "Doctor",
    name: "Doctor",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 122.47 122.88"
        fill="none"
      >
        <path
          d="M84.58,103.47a4.09,4.09,0,1,1-4.08,4.09,4.08,4.08,0,0,1,4.08-4.09Zm3.61-60.62a3.89,3.89,0,0,1,2.2,1.48c1.08,1.39,1.38,3.64,1.08,6a15.16,15.16,0,0,1-2.21,6.2c-1.31,2-3,3.29-5,3.16-.14,6.51-3.33,9.5-7.49,13.41l-1.59,1.51-.54.51.13.09a14.67,14.67,0,0,1-1.58,1.1,17.71,17.71,0,0,1-4.61,2.47,20.48,20.48,0,0,1-6.84,1.12,21.4,21.4,0,0,1-7.11-1.1l-1-.36a16.18,16.18,0,0,1-3.74-1.66l-.5-.31a21.59,21.59,0,0,1-2.26,4.77L62.65,92.05,77.23,79.9A22.93,22.93,0,0,1,75,75.38c6.43,4.57,7.82,14.11,7.61,21.81,0,1-.06,1.26-.08,1.59a8.91,8.91,0,0,0-4.36,15,8.49,8.49,0,0,0,11.77.7,8.9,8.9,0,0,0,3.42-7,7.94,7.94,0,0,0-1.08-4c-1.5-2.6-3.13-3.36-5.62-4.6-.17-.09,0-.47,0-1.53a47.43,47.43,0,0,0-1.46-14.08,21,21,0,0,0,3.4,1.41c8.9,2.1,19.84,3,23.76,5.2a16,16,0,0,1,5,4.26c3.47,4.58,3.76,17.76,5,23.36-.31,3.28-2.16,5.16-5.82,5.44H5.82C2.17,122.6.31,120.71,0,117.44c1.26-5.6,1.56-18.79,5-23.36a15.58,15.58,0,0,1,5.05-4.26c5.57-3.1,19.22-3.94,28.3-6.46a33.06,33.06,0,0,0-1.58,8c-1,.77-3.64,1.67-4.47,2.66a38.55,38.55,0,0,0-3.86,5.53,2,2,0,0,0-.27,1c0,.28.29.57.17.81l-.19.37c-2.6,5-4.29,10.61-3.49,13A3.64,3.64,0,0,0,27.3,117a12.43,12.43,0,0,0,3.15.41c.31,0,.63,0,.94,0a3.07,3.07,0,0,0,.52.39,4.12,4.12,0,0,0,.67.32,2.58,2.58,0,0,0,.91.17A2.51,2.51,0,0,0,36,115.75a2.54,2.54,0,0,0-.23-1,2.58,2.58,0,0,0-2.38-1.61c-.92,0-2.23.46-2.23,1.38v0l0,.06-.64,0a9.17,9.17,0,0,1-2.33-.28c-.45-.12-.71-.29-.77-.48-.58-1.68,1-6.33,3.29-10.83l.29-.55a2,2,0,0,0,1-.88,34,34,0,0,1,3.41-4.92,7.09,7.09,0,0,1,3.38-1.72H39a10.53,10.53,0,0,1,1.72,1.55,30.64,30.64,0,0,1,3.6,5c.23.41.79.5,1,.89,2.65,4.28,4.14,9.19,3.78,11.06-.08.44-.44.7-1,.88a10.49,10.49,0,0,1-2.62.37,1.74,1.74,0,0,0-.1-.19v0c0-.92-1.32-1.35-2.24-1.38a2.58,2.58,0,0,0-2.38,1.61,2.71,2.71,0,0,0-.23,1,2.51,2.51,0,0,0,2.51,2.51,2.63,2.63,0,0,0,.92-.17,4,4,0,0,0,.66-.32,3.27,3.27,0,0,0,.36-.25h.36A12.22,12.22,0,0,0,49,117a3.88,3.88,0,0,0,2.9-3.05c.44-2.44-1.33-7.82-3.94-12.7a2,2,0,0,0,.16-.81,2.13,2.13,0,0,0-.28-1,36,36,0,0,0-4.1-5.7c-.83-.93-2.66-1.2-2.85-2.44-.5-3.23.9-7.23,3-10.71a15.15,15.15,0,0,0,1.46-2.19l.32-.44a8.32,8.32,0,0,1,3.41-2.08q-.73-.55-1.47-1.2L46.07,73.3l-.1-.09c-4-3.48-7.41-6.43-8-13.56-2.78-.24-4.75-2.88-5.72-6a15.2,15.2,0,0,1-.65-5.14,7.82,7.82,0,0,1,1.51-4.56,4.31,4.31,0,0,1,.63-.65l-.14-.09c-.64-8,1.23-21.82-7.43-24.44C42.51-1.55,60.51-5.27,75.6,7.13,91.28,8,98.85,30.64,88.19,42.85Z"
          fill="black"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  //patient
  {
    url: Path.patient,
    model_name: "Patient",
    name: "Patient",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 459.384 459.384"
        fill="none"
      >
        <path
          d="M117.31,178.834l105.938,69.969c8.365,5.525,19.437,4.672,26.859-2.121c3.935-1.236-1.911,2.226,84.107-54.543
            l90.077,13.361c11.269,1.672,21.772-6.112,23.445-17.388c1.673-11.275-6.112-21.772-17.388-23.445l-97.885-14.519
            c-5.029-0.747-10.154,0.39-14.397,3.19l-42.884,28.302l-17.292-13.48c-9.782,10.236-7.344,7.684-17.528,18.34
            c-6.994,7.318-17.698,8.984-26.384,4.909l-62.156-29.269c70.819,12.611,66.147,11.895,68.314,11.895
            c4.652,0,9.16-1.891,12.434-5.317l47.478-49.679c6.563-6.868,6.316-17.755-0.551-24.318c-6.869-6.563-17.757-6.316-24.319,0.551
            l-41.106,43.012l-56.219-10.011l43.922-3.86l-27.733-21.62c-11.17-8.708-27.285-6.712-35.993,4.458l-26.83,34.416
            C102.032,153.45,104.83,170.591,117.31,178.834z"
          fill="currentColor"
        />
        <circle cx="78.871" cy="90.141" r="37.963" fill="currentColor" />
        <path
          d="M435.425,275.642c9.276,3.358,19.526-1.439,22.887-10.72c3.36-9.28-1.44-19.527-10.72-22.887l-91.068-32.972
            c-5.222-1.891-11.027-1.246-15.708,1.745l-103.222,65.969L27.693,138.727c-8.246-5.422-19.328-3.135-24.751,5.112
            c-5.423,8.246-3.136,19.328,5.111,24.751l219.583,144.417c2.978,1.959,6.398,2.94,9.82,2.94c3.343,0,6.689-0.937,9.623-2.813
            l10.533-6.732l30.756,65.062h-51.031c-9.87,0-17.871,8.001-17.871,17.871s8.001,17.871,17.871,17.871H438.66
            c9.87,0,17.871-8.001,17.871-17.871s-8.001-17.871-17.871-17.871h-54.717l-49.685-114.047l18.382-11.748L435.425,275.642z"
          fill="currentColor"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  {
    url: Path.clergy,
    model_name: "Clergy",
    name: "Clergy",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.18062 0.56447C5.55549 0.56447 4.22168 1.99259 4.22168 3.78809C4.22168 5.58356 5.55549 7.01169 7.18065 7.01169C8.80587 7.01169 10.1406 5.58356 10.1406 3.78806C10.1406 1.99256 8.80587 0.564407 7.18065 0.564407L7.18062 0.56447ZM5.34374 4.98922C5.75862 5.10391 6.16855 5.17816 6.57421 5.21484V5.80078C6.11565 5.76297 5.65346 5.68047 5.18749 5.55172L5.34374 4.98922ZM9.01171 4.98922L9.16502 5.55266C8.7134 5.67572 8.25627 5.75838 7.79396 5.79781V5.21288C8.20287 5.17466 8.60818 5.09919 9.01177 4.98925L9.01171 4.98922ZM4.00687 5.4795C1.65349 7.06691 0.550492 9.39225 0.373055 12.3545H0.379867C0.368172 12.4087 0.362285 12.464 0.362305 12.5195C0.362305 12.951 0.711992 13.3008 1.14355 13.3008C1.15043 13.3008 1.15718 13.3 1.16405 13.2998V13.3067L6.77149 13.3066V9.45019C5.97212 9.60081 5.35837 10.3405 5.35837 11.4063V11.6983H2.22174V11.1143H2.61918C2.73368 10.0149 3.44799 8.67681 4.03615 7.94725L4.49021 8.3135C4.00215 8.91891 3.34637 10.2405 3.21193 11.1143H4.78912C4.91537 9.79925 5.88812 8.83691 7.07724 8.83691C8.17037 8.83691 9.22265 9.74185 9.38677 11.1143H11.129C10.9598 10.2298 10.2999 8.91678 9.81352 8.3135L10.2686 7.94734C10.8588 8.67934 11.57 10.025 11.7237 11.1143H12.0538V11.6983H8.83102L8.82321 11.4141C8.79134 10.2999 8.08665 9.59431 7.3554 9.44928V13.3067H13.0009V13.2998C13.0078 13.3 13.0146 13.3008 13.0215 13.3008C13.4531 13.3008 13.8027 12.9511 13.8027 12.5196C13.8027 12.4542 13.7944 12.3908 13.7793 12.3301C13.6054 9.43622 12.5599 7.15319 10.3096 5.57331C9.71499 6.77191 8.54106 7.59581 7.18065 7.59581C5.78496 7.59581 4.58543 6.72894 4.0069 5.47956L4.00687 5.4795ZM3.38668 13.8906L3.6738 15.375H10.5664L10.8311 13.8906H3.38668Z"
          fill="currentColor"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  {
    url: Path.chemist,
    model_name: "Chemist",
    name: "Chemist",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        height="21px"
        width="21px"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 504.123 504.123"
        xmlSpace="preserve"
      >
        <g>
          <path
            style={{ fill: "#D1B302" }}
            d="M241.073,203.768c10.027,11.28,3.663,33.296-14.218,49.215   c-17.881,15.896-114.018,85.031-124.062,73.767c-10.012-11.296,69.892-98.706,87.773-114.601   C208.431,196.246,231.046,192.496,241.073,203.768z"
          />
          <path
            style={{ fill: "#D1B302" }}
            d="M263.05,203.768c-10.027,11.28-3.663,33.296,14.218,49.215   c17.881,15.896,114.018,85.031,124.062,73.767c10.012-11.296-69.892-98.706-87.773-114.601   C295.692,196.246,273.077,192.496,263.05,203.768z"
          />
        </g>
        <g>
          <path
            style={{ fill: "#B79904" }}
            d="M348.538,358.951c0,19.511-15.817,124.676-35.336,124.676c-19.495,0-35.304-105.173-35.304-124.676   c0-19.495,15.817-35.32,35.304-35.32C332.721,323.631,348.538,339.464,348.538,358.951z"
          />
          <path
            style={{ fill: "#B79904" }}
            d="M228.218,361.905c0,19.511-15.817,124.676-35.336,124.676c-19.495,0-35.304-105.173-35.304-124.676   c0-19.495,15.817-35.32,35.304-35.32C212.401,326.585,228.218,342.418,228.218,361.905z"
          />
        </g>
        <path
          style={{ fill: "#CE1111" }}
          d="M351.705,315.242c0,126.322-44.599,84.259-99.643,84.259c-55.028,0-99.643,42.063-99.643-84.259  c0-72.231,44.631-130.788,99.643-130.788C307.09,184.462,351.705,243.019,351.705,315.242z"
        />
        <path
          style={{ fill: "#D1B302" }}
          d="M351.705,315.242c0,126.322-44.599,84.259-99.643,84.259c-55.028,0-99.643,42.063-99.643-84.259  c0-72.231,44.631-130.788,99.643-130.788C307.09,184.462,351.705,243.019,351.705,315.242z"
        />
        <path
          style={{ fill: "#EACE00" }}
          d="M252.062,184.462c-53.28,0-96.681,54.957-99.383,124.014c3.513,107.874,46.655,69.372,99.383,69.372  c52.744,0,95.862,38.51,99.383-69.372C348.743,239.419,305.349,184.462,252.062,184.462z"
        />
        <path
          style={{ fill: "#232728" }}
          d="M232.629,487.219c0,14.935-17.802,16.904-39.739,16.904s-39.739-1.969-39.739-16.904  c0-14.935,17.802-35.509,39.739-35.509S232.629,472.277,232.629,487.219z"
        />
        <path d="M232.629,487.219c0,14.935-17.802,16.904-39.739,16.904s-39.739-1.969-39.739-16.904" />
        <path
          style={{ fill: "#232728" }}
          d="M350.988,487.219c0,14.935-17.802,16.904-39.739,16.904s-39.739-1.969-39.739-16.904  c0-14.935,17.802-35.509,39.739-35.509S350.988,472.277,350.988,487.219z"
        />
        <path d="M350.988,487.219c0,14.935-17.802,16.904-39.739,16.904s-39.739-1.969-39.739-16.904" />
        <path
          style={{ fill: "#D1B302" }}
          d="M173.088,235.725c21.835,11.059,49.191,16.691,78.99,16.691c29.783,0,57.139-5.632,78.966-16.691  c-18.211-31.106-46.773-51.263-78.982-51.263C219.861,184.462,191.291,204.603,173.088,235.725z"
        />
        <polygon
          style={{ fill: "#FFFFFF" }}
          points="298.016,207.415 252.062,307.2 206.108,207.415 252.062,161.461 "
        />
        <path
          style={{ fill: "#EAE5DF" }}
          d="M280.513,189.913c-9.011-3.529-18.558-5.451-28.451-5.451s-19.448,1.914-28.459,5.451l-17.495,17.503  l19.999,43.433c8.397,1,17.046,1.568,25.97,1.568c8.901,0,17.558-0.567,25.939-1.568l20-43.433L280.513,189.913z"
        />
        <path
          style={{ fill: "#F7CCB0" }}
          d="M381.015,124.258c0,63-57.738,94.681-128.937,94.681c-71.215,0-128.969-31.673-128.969-94.681  C123.108,61.227,180.862,0,252.077,0C323.277,0,381.015,61.227,381.015,124.258z"
        />
        <path
          style={{ fill: "#F7BC8F" }}
          d="M381.015,124.258c0,63-57.738,94.681-128.937,94.681c-71.215,0-128.969-31.673-128.969-94.681  c0-63.031,57.754-105.236,128.969-105.236C323.277,19.023,381.015,61.227,381.015,124.258z"
        />
        <path
          style={{ fill: "#EAAF88" }}
          d="M381.015,124.258c0,63-57.738,94.681-128.937,94.681c-71.215,0-128.969-31.673-128.969-94.681"
        />
        <circle
          style={{ fill: "#113E49" }}
          cx="190.748"
          cy="133.569"
          r="11.532"
        />
        <path d="M202.279,133.569c0,6.388-5.167,11.54-11.54,11.54c-6.372,0-11.524-5.152-11.524-11.54" />
        <path
          style={{ fill: "#FFD3C5" }}
          d="M213.496,157.633c-0.614,0-1.245-0.228-1.725-0.725c-5.632-5.616-13.107-8.72-21.047-8.72h-0.016  c-7.94,0-15.399,3.111-21,8.72c-0.953,0.953-2.489,0.969-3.434,0c-0.953-0.922-0.985-2.458-0.031-3.419  c6.538-6.538,15.218-10.153,24.458-10.153h0.016c9.263,0,17.951,3.584,24.505,10.138c0.937,0.937,0.937,2.505,0,3.434  C214.756,157.397,214.142,157.633,213.496,157.633z"
        />
        <circle
          style={{ fill: "#113E49" }}
          cx="313.423"
          cy="133.569"
          r="11.532"
        />
        <path d="M301.859,133.569c0,6.388,5.151,11.54,11.54,11.54c6.372,0,11.524-5.152,11.524-11.54" />
        <path
          style={{ fill: "#FFD3C5" }}
          d="M290.643,157.633c0.599,0,1.229-0.228,1.709-0.725c5.632-5.616,13.107-8.72,21.047-8.72h0.016  c7.94,0,15.415,3.111,21.016,8.72c0.937,0.953,2.473,0.969,3.434,0c0.953-0.922,0.969-2.458,0.016-3.419  c-6.506-6.538-15.218-10.153-24.458-10.153h-0.016c-9.248,0-17.936,3.584-24.505,10.138c-0.922,0.937-0.922,2.505,0,3.434  C289.382,157.397,289.997,157.633,290.643,157.633z"
        />
        <g>
          <path
            style={{ fill: "#845824" }}
            d="M216.954,168.164h-56.8c-11.24,0-20.385-9.145-20.385-20.385v-30.744   c0-11.24,9.145-20.385,20.385-20.385h56.8c11.24,0,20.385,9.145,20.385,20.385v30.744   C237.34,159.019,228.194,168.164,216.954,168.164z M160.154,112.404c-2.552,0-4.632,2.08-4.632,4.632v30.744   c0,2.552,2.079,4.632,4.632,4.632h56.8c2.552,0,4.632-2.08,4.632-4.632v-30.744c0-2.552-2.079-4.632-4.632-4.632   C216.954,112.404,160.154,112.404,160.154,112.404z"
          />
          <path
            style={{ fill: "#845824" }}
            d="M145.676,140.28h-30.523c-4.356,0-7.877-3.521-7.877-7.877c0-4.356,3.521-7.877,7.877-7.877h30.523   c4.356,0,7.877,3.521,7.877,7.877C153.553,136.759,150.032,140.28,145.676,140.28z"
          />
          <path
            style={{ fill: "#845824" }}
            d="M343.969,168.157h-56.801c-11.24,0-20.385-9.145-20.385-20.385v-30.736   c0-11.24,9.145-20.385,20.385-20.385h56.801c11.24,0,20.385,9.145,20.385,20.385v30.736   C364.355,159.011,355.21,168.157,343.969,168.157z M287.169,112.404c-2.552,0-4.632,2.08-4.632,4.632v30.736   c0,2.552,2.079,4.632,4.632,4.632h56.801c2.552,0,4.632-2.08,4.632-4.632v-30.736c0-2.552-2.079-4.632-4.632-4.632   C343.969,112.404,287.169,112.404,287.169,112.404z"
          />
          <path
            style={{ fill: "#845824" }}
            d="M388.97,140.28h-30.523c-4.356,0-7.877-3.521-7.877-7.877c0-4.356,3.521-7.877,7.877-7.877h30.523   c4.356,0,7.877,3.521,7.877,7.877C396.847,136.759,393.326,140.28,388.97,140.28z"
          />
          <path
            style={{ fill: "#845824" }}
            d="M274.66,138.004h-43.811c-4.356,0-7.877-3.521-7.877-7.877c0-4.356,3.521-7.877,7.877-7.877h43.811   c4.356,0,7.877,3.521,7.877,7.877C282.537,134.483,279.016,138.004,274.66,138.004z"
          />
        </g>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M257.308,381.369c0,2.891-2.339,5.246-5.246,5.246l0,0c-2.891,0-5.246-2.355-5.246-5.246v-85.339  c0-2.907,2.355-5.254,5.246-5.254l0,0c2.907,0,5.246,2.347,5.246,5.254V381.369z"
        />
        <path
          style={{ fill: "#513715" }}
          d="M266.398,165.935H237.71c-13.273,0-24.033,10.768-24.033,24.033v18.692  c0,13.273,10.76,24.025,24.033,24.025h28.688c13.296,0,24.033-10.752,24.033-24.025v-18.692  C290.43,176.711,279.694,165.935,266.398,165.935z M274.653,200.814c0,7.814-6.333,14.147-14.147,14.147H243.61  c-7.814,0-14.155-6.333-14.155-14.147v-10.996c0-7.806,6.341-14.155,14.155-14.155h16.896c7.814,0,14.147,6.349,14.147,14.155  V200.814z"
        />
        <path
          style={{ fill: "#227FEF" }}
          d="M128.323,330.831c0,11.973-9.689,21.662-21.662,21.662l0,0c-11.973,0-21.662-9.689-21.662-21.662l0,0  c0-11.973,9.689-21.662,21.662-21.662l0,0C118.634,309.169,128.323,318.858,128.323,330.831L128.323,330.831z"
        />
        <path
          style={{ fill: "#0A5BDD" }}
          d="M106.661,309.169L106.661,309.169c11.973,0,21.662,9.689,21.662,21.662l0,0  c0,11.973-9.689,21.662-21.662,21.662l0,0"
        />
        <path
          style={{ fill: "#227FEF" }}
          d="M375.784,330.831c0-11.981,9.689-21.677,21.662-21.677l0,0c11.973,0,21.677,9.689,21.677,21.677l0,0  c0,11.957-9.704,21.662-21.677,21.662l0,0C385.481,352.492,375.784,342.788,375.784,330.831L375.784,330.831z"
        />
        <path
          style={{ fill: "#0A5BDD" }}
          d="M397.446,352.492L397.446,352.492c-11.973,0-21.662-9.704-21.662-21.662l0,0  c0-11.981,9.689-21.677,21.662-21.677l0,0"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  // feedback
  // {
  //   url: Path.prompt,
  //   model_name: "Prompt",
  //   name: "Prompt",
  //   //   sidebar_icon: "fas fa-fire",
  //   sidebar_icon: (
  //     <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     fill="#000000"
  //     width="28px"
  //     height="28px"
  //     viewBox="0 0 52 52"
  //     enableBackground="new 0 0 52 52"
  //     xmlSpace="preserve"
  //   >
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M47,4.5H5c-1.7,0-3,1.3-3,3v30.6c0,1.7,1.3,3,3,3h14.5l3.6,5.2  c1,1.4,2.8,1.7,4.2,0.7c0.2-0.2,0.4-0.4,0.6-0.6l4.2-5.3H47c1.7,0,3-1.3,3-3V7.5C50,5.8,48.7,4.5,47,4.5z"
  //     />
  //   </svg>
  //   ),
  //   icon: "far fa fa-user",
  //   dashboard: false,
  //   is_modules: false,
  //   is_permission: true,
  //   is_sidebar: true,
  //   is_dropdown: false,
  //   is_open: false,
  //   count: 0,
  //   sub_modules: {},
  // },
  {
    url: Path.feedback,
    model_name: "feedback",
    name: "Feedback",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2H18C18.55 2 19 2.45 19 3V17C19 17.55 18.55 18 18 18H2C1.45 18 1 17.55 1 17V3C1 2.45 1.45 2 2 2ZM17 16V7H3V16H17ZM4 8V9H7V8H4ZM8 8V11H16V8H8ZM4 12V13H7V12H4ZM8 12V15H16V12H8Z"
          fill="black"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: true,
    is_open: false,
    count: 0,
    sub_modules: [
      {
        url: Path.feedback,
        model_name: "feedback",
        name: "All Feedback",
        //   sidebar_icon: "fas fa-fire",
        sidebar_icon: (
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.75 14C17.62 14 17.48 13.98 17.35 13.94C17.1013 13.856 16.8854 13.6959 16.7328 13.4823C16.5802 13.2687 16.4988 13.0125 16.5 12.75V10.99C15.1 10.86 14 9.68 14 8.25V4.75C14 3.23 15.23 2 16.75 2H23.25C24.77 2 26 3.23 26 4.75V8.25C26 9.77 24.77 11 23.25 11H20.63L18.75 13.5C18.51 13.82 18.14 14 17.75 14ZM9.49999 16.5C8.37363 16.4974 7.29416 16.0487 6.4977 15.2523C5.70124 14.4558 5.25263 13.3764 5.24999 12.25C5.25263 11.1236 5.70124 10.0442 6.4977 9.24771C7.29416 8.45126 8.37363 8.00264 9.49999 8C10.6263 8.00264 11.7058 8.45126 12.5023 9.24771C13.2987 10.0442 13.7473 11.1236 13.75 12.25C13.7473 13.3764 13.2987 14.4558 12.5023 15.2523C11.7058 16.0487 10.6263 16.4974 9.49999 16.5ZM3.47099 23.92C4.78099 25.3 6.81099 26 9.50099 26C12.191 26 14.221 25.3 15.531 23.92C17.053 22.31 17.004 20.367 17.001 20.236V20.23C17.001 19 16.001 18 14.771 18H4.23099C3.00099 18 2.00099 19 2.00099 20.19V20.203C1.99699 20.393 1.95899 22.32 3.47099 23.92Z"
              fill="black"
            />
          </svg>
        ),
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: true,
        is_dropdown: false,
        is_open: false,
        count: 0,
      },
      {
        url: Path.pendingFeedback,
        model_name: "Pending Feedback",
        name: "Pending Feedback",
        //   sidebar_icon: "fas fa-fire",
        sidebar_icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 12C14.24 12 12 14.24 12 17C12 19.76 14.24 22 17 22C19.76 22 22 19.76 22 17C22 14.24 19.76 12 17 12ZM18.65 19.35L16.5 17.2V14H17.5V16.79L19.35 18.64L18.65 19.35ZM18 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H6C4.9 3 4 3.9 4 5V20C4 21.1 4.9 22 6 22H12.11C11.5176 21.4264 11.0362 20.7484 10.69 20H6V5H8V8H16V5H18V10.08C18.71 10.18 19.38 10.39 20 10.68V5C20 3.9 19.1 3 18 3ZM12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5Z"
              fill="black"
            />
          </svg>
        ),
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: true,
        is_dropdown: false,
        is_open: false,
        count: 0,
      },
      {
        url: Path.groupSummary,
        model_name: "Group Summarization",
        name: "Group Summarization",
        //sidebar_icon: "fas fa-fire",
        sidebar_icon: (
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 18C7.45 18 6.97933 17.8043 6.588 17.413C6.19667 17.0217 6.00067 16.5507 6 16V4C6 3.45 6.196 2.97933 6.588 2.588C6.98 2.19667 7.45067 2.00067 8 2H20C20.55 2 21.021 2.196 21.413 2.588C21.805 2.98 22.0007 3.45067 22 4V16C22 16.55 21.8043 17.021 21.413 17.413C21.0217 17.805 20.5507 18.0007 20 18H8ZM4 22C3.45 22 2.97933 21.8043 2.588 21.413C2.19667 21.0217 2.00067 20.5507 2 20V7C2 6.71667 2.096 6.47933 2.288 6.288C2.48 6.09667 2.71733 6.00067 3 6C3.28267 5.99933 3.52033 6.09533 3.713 6.288C3.90567 6.48067 4.00133 6.718 4 7V20H17C17.2833 20 17.521 20.096 17.713 20.288C17.905 20.48 18.0007 20.7173 18 21C17.9993 21.2827 17.9033 21.5203 17.712 21.713C17.5207 21.9057 17.2833 22.0013 17 22H4ZM8 6H20V4H8V6Z"
              fill="black"
            />
          </svg>
        ),
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: true,
        is_dropdown: false,
        is_open: false,
        count: 0,
      },
    ],
  },
  {
    url: Path.adminlogs,
    model_name: "logs",
    name: "Logs",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="#000000"
        height="18px"
        width="18px"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g>
          <g>
            <path d="M235.082,392.745c-5.771,0-10.449,4.678-10.449,10.449v4.678c0,5.771,4.678,10.449,10.449,10.449    c5.77,0,10.449-4.678,10.449-10.449v-4.678C245.531,397.423,240.853,392.745,235.082,392.745z" />
          </g>
        </g>
        <g>
          <g>
            <path d="M492.948,313.357l-31.393-25.855c1.58-10.4,2.38-20.968,2.38-31.502c0-10.534-0.8-21.104-2.381-31.504l31.394-25.856    c10.032-8.262,12.595-22.42,6.099-33.66L456.35,91.029c-4.704-8.173-13.479-13.25-22.903-13.25c-3.19,0-6.326,0.573-9.302,1.695    l-38.109,14.274c-16.546-13.286-34.848-23.869-54.55-31.54l-6.683-40.082C322.676,9.306,311.701,0,298.704,0h-85.408    C200.3,0,189.324,9.307,187.2,22.119l-6.684,40.088c-19.703,7.673-38.007,18.255-54.553,31.542L87.898,79.492    c-2.999-1.138-6.14-1.715-9.338-1.715c-9.414,0-18.191,5.074-22.903,13.241l-42.702,73.96    c-6.499,11.244-3.935,25.403,6.097,33.664l31.394,25.855c-1.58,10.4-2.38,20.969-2.38,31.503c0,10.534,0.8,21.103,2.38,31.503    l-31.394,25.856c-10.032,8.262-12.595,22.42-6.099,33.66l42.703,73.963c4.716,8.171,13.492,13.247,22.904,13.247    c3.205,0,6.352-0.581,9.294-1.703l38.107-14.275c16.547,13.287,34.85,23.87,54.551,31.541l6.682,40.075    C189.316,502.692,200.293,512,213.297,512h85.408c12.991,0,23.967-9.304,26.096-22.118l6.683-40.089    c19.705-7.673,38.008-18.255,54.554-31.542l38.07,14.261c2.999,1.137,6.141,1.713,9.336,1.713c9.411,0,18.185-5.074,22.9-13.241    l42.703-73.962C505.543,335.776,502.979,321.619,492.948,313.357z M298.704,491.102H245.53v-49.427    c0-5.771-4.678-10.449-10.449-10.449c-5.771,0-10.449,4.678-10.449,10.449v49.427h-10.922V376.504    c13.606,4.844,28.061,7.375,42.865,7.382c0.003,0,0.066,0,0.07,0c14.852,0,29.325-2.528,42.928-7.376v114.515h0.001    C299.289,491.069,299,491.102,298.704,491.102z M256.642,362.988h-0.057c-58.964-0.029-106.933-48.026-106.932-106.99    c0.001-34.314,16.175-65.814,43.158-85.745v76.229c0,3.671,1.926,7.072,5.073,8.96l53.381,32.027    c3.309,1.984,7.443,1.984,10.752,0l53.381-32.027c3.147-1.889,5.073-5.29,5.073-8.96v-76.229    c26.983,19.931,43.159,51.432,43.157,85.747c0,28.528-11.143,55.382-31.374,75.614    C312.022,351.846,285.169,362.988,256.642,362.988z M480.949,336.57l-42.705,73.965c-1.326,2.296-4.122,3.423-6.769,2.42    l-43.772-16.397c-3.557-1.331-7.555-0.63-10.444,1.834c-16.925,14.428-36.026,25.589-56.79,33.212v-64.779    c9.585-5.551,18.513-12.386,26.56-20.434c24.179-24.18,37.495-56.281,37.495-90.391c0.001-48.242-26.729-91.831-69.76-113.754    c-3.239-1.651-7.103-1.498-10.203,0.401c-3.099,1.9-4.989,5.274-4.989,8.909v89.011l-42.932,25.759l-42.932-25.759v-89.011    c0-3.635-1.89-7.009-4.989-8.909c-3.099-1.899-6.963-2.05-10.203-0.401c-43.03,21.922-69.76,65.51-69.762,113.752    c-0.001,34.743,13.583,67.154,38.247,91.26c7.858,7.68,16.53,14.23,25.809,19.585v65.235    c-21.258-7.63-40.795-18.958-58.071-33.684c-1.922-1.638-4.333-2.497-6.78-2.497c-1.232,0-2.473,0.217-3.663,0.664l-43.83,16.419    c-0.613,0.234-1.255,0.353-1.905,0.353c-1.969,0-3.81-1.071-4.805-2.796l-42.706-73.968c-1.365-2.361-0.822-5.337,1.288-7.076    L68.389,299.8c2.926-2.411,4.318-6.216,3.635-9.944c-2.03-11.12-3.061-22.509-3.061-33.856c0-11.346,1.03-22.736,3.063-33.854    c0.681-3.729-0.709-7.535-3.636-9.944l-36.051-29.691c-2.112-1.74-2.654-4.716-1.287-7.08l42.705-73.966    c1.323-2.294,4.109-3.429,6.769-2.419l43.772,16.396c3.555,1.33,7.554,0.63,10.444-1.833    c17.417-14.847,37.129-26.244,58.589-33.876c3.576-1.272,6.182-4.382,6.805-8.126l7.679-46.059    c0.446-2.694,2.752-4.649,5.482-4.649h85.408c2.73,0,5.036,1.955,5.485,4.656l7.679,46.053c0.624,3.744,3.23,6.856,6.806,8.126    c21.459,7.631,41.17,19.027,58.586,33.874c2.89,2.463,6.888,3.165,10.444,1.833l43.794-16.405c0.631-0.238,1.287-0.358,1.95-0.358    c1.97,0,3.805,1.064,4.798,2.789l42.706,73.967c1.365,2.361,0.822,5.337-1.288,7.076l-36.052,29.692    c-2.926,2.411-4.318,6.215-3.635,9.944c2.03,11.118,3.061,22.509,3.061,33.855c0,11.346-1.03,22.735-3.063,33.853    c-0.681,3.728,0.709,7.535,3.636,9.944l36.051,29.691C481.774,331.227,482.316,334.205,480.949,336.57z" />
          </g>
        </g>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  {
    url: Path.support,
    model_name: "Support",
    name: "Support",
    //sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        height="28px"
        width="28px"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 508 508"
        xmlSpace="preserve"
      >
        <circle style={{ fill: "#54C0EB" }} cx={254} cy={254} r={254} />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M303.7,303.3c30.5-17.3,51-50.1,51-87.6c0-55.7-45.1-100.8-100.8-100.8S153.2,160,153.2,215.6  c0,37.6,20.6,70.3,51,87.6C141,319.3,89.7,365,66,424.8c46.5,51.1,113.5,83.2,188,83.2s141.5-32.1,188-83.2  C418.3,365,367,319.3,303.7,303.3z"
        />
        <path
          style={{ fill: "#324A5E" }}
          d="M401.6,182.3h-15.8C370.9,123.4,317.5,79.6,254,79.6s-116.9,43.7-131.8,102.7h-15.8  c-5.4,0-9.8,4.4-9.8,9.8V240c0,5.4,4.4,9.8,9.8,9.8h20c6.1,0,10.8-5.5,9.7-11.4c-2-10.4-2.7-21.3-1.8-32.5  c4.8-59.3,53.6-106.9,113.1-110.1c69.2-3.8,126.8,51.5,126.8,119.9c0,7.8-0.8,15.3-2.2,22.7c-1.2,6,3.6,11.5,9.6,11.5h1.8  c-4.2,13-14.9,37.2-38.3,50.2c-19.6,10.9-44.3,11.9-73.4,2.8c-1.5-6.7-8.9-14.6-16.5-18.3c-9.8-4.9-15.9-0.8-19.4,6.2  s-3,14.3,6.7,19.2c8.6,4.3,21.6,5.2,27,0.5c13.9,4.3,26.9,6.5,39,6.5c15,0,28.5-3.3,40.4-10c27.5-15.3,38.8-43.7,42.8-57.2h9.9  c5.4,0,9.8-4.4,9.8-9.8v-47.9C411.4,186.7,407,182.3,401.6,182.3z"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  {
    url: Path.broadcast,
    model_name: "Broadcast",
    name: "Broadcast",
    //sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1_2)">
          <path
            d="M8.75001 8.582V14.25C8.75001 14.4489 8.67099 14.6397 8.53034 14.7803C8.38969 14.921 8.19892 15 8.00001 15C7.8011 15 7.61033 14.921 7.46968 14.7803C7.32903 14.6397 7.25001 14.4489 7.25001 14.25V8.582C6.89102 8.41171 6.60066 8.12433 6.42668 7.76711C6.25271 7.40989 6.20547 7.0041 6.29275 6.61647C6.38002 6.22884 6.59661 5.88245 6.90689 5.63426C7.21717 5.38607 7.60268 5.25086 8.00001 5.25086C8.39734 5.25086 8.78285 5.38607 9.09313 5.63426C9.40341 5.88245 9.62 6.22884 9.70727 6.61647C9.79455 7.0041 9.74731 7.40989 9.57334 7.76711C9.39936 8.12433 9.109 8.41171 8.75001 8.582ZM12.733 1.457C12.8771 1.31994 13.0696 1.24569 13.2684 1.25057C13.4672 1.25544 13.6559 1.33904 13.793 1.483C15.2115 2.96932 16.002 4.94546 16 7C16 9.139 15.16 11.083 13.793 12.517C13.7259 12.5912 13.6445 12.6512 13.5538 12.6935C13.4631 12.7358 13.3648 12.7595 13.2648 12.7633C13.1648 12.767 13.065 12.7506 12.9714 12.7152C12.8778 12.6798 12.7922 12.626 12.7197 12.557C12.6472 12.4879 12.5893 12.4051 12.5493 12.3133C12.5093 12.2216 12.4881 12.1227 12.4869 12.0227C12.4858 11.9226 12.5046 11.8233 12.5424 11.7306C12.5802 11.6379 12.6362 11.5537 12.707 11.483C13.8607 10.276 14.5032 8.66971 14.5 7C14.5032 5.33029 13.8607 3.72399 12.707 2.517C12.57 2.37296 12.4957 2.18039 12.5006 1.98162C12.5055 1.78285 12.5891 1.59415 12.733 1.457ZM3.26701 1.457C3.56701 1.743 3.57901 2.217 3.29301 2.517C2.13927 3.72399 1.49682 5.33029 1.50001 7C1.49682 8.66971 2.13927 10.276 3.29301 11.483C3.42426 11.628 3.49365 11.8186 3.48637 12.0141C3.47909 12.2096 3.39573 12.3945 3.25406 12.5294C3.11238 12.6643 2.92361 12.7385 2.72801 12.7362C2.53241 12.7339 2.34545 12.6552 2.20701 12.517C0.787679 11.0312 -0.0029961 9.05474 8.53211e-06 7C8.53211e-06 4.861 0.840009 2.917 2.20701 1.483C2.34416 1.33904 2.53286 1.25544 2.73163 1.25057C2.9304 1.24569 3.12297 1.31994 3.26701 1.457ZM11.823 3.778C12.583 4.67961 12.9999 5.82081 13 7C12.9999 8.17919 12.583 9.32039 11.823 10.222C11.7605 10.3003 11.6829 10.3652 11.5948 10.413C11.5068 10.4607 11.4101 10.4904 11.3104 10.5002C11.2107 10.51 11.11 10.4997 11.0144 10.4699C10.9187 10.4402 10.83 10.3916 10.7535 10.327C10.6769 10.2624 10.6141 10.1831 10.5686 10.0938C10.5232 10.0045 10.4962 9.90703 10.489 9.80711C10.4819 9.7072 10.4949 9.60686 10.5272 9.51204C10.5594 9.41721 10.6104 9.32981 10.677 9.255C11.2086 8.62385 11.5001 7.82518 11.5 7C11.5 6.14 11.191 5.355 10.677 4.745C10.555 4.59232 10.4974 4.39803 10.5165 4.20351C10.5356 4.00899 10.6298 3.8296 10.7792 3.70356C10.9286 3.57751 11.1213 3.51476 11.3162 3.52866C11.5112 3.54256 11.693 3.63203 11.823 3.778ZM5.33101 4.736C4.79301 5.36749 4.4983 6.17041 4.50001 7C4.49821 7.82549 4.7899 8.62474 5.32301 9.255C5.44503 9.40768 5.50263 9.60197 5.48354 9.79649C5.46445 9.99101 5.37018 10.1704 5.2208 10.2964C5.07142 10.4225 4.87874 10.4852 4.68378 10.4713C4.48882 10.4574 4.30699 10.368 4.17701 10.222C3.4155 9.32127 2.9984 8.17949 3.00001 7C2.99815 5.8143 3.4194 4.66684 4.18801 3.764C4.3169 3.61243 4.50073 3.51827 4.69905 3.50223C4.89737 3.4862 5.09394 3.5496 5.24551 3.6785C5.39708 3.80739 5.49124 3.99122 5.50727 4.18954C5.52331 4.38786 5.4599 4.58443 5.33101 4.736Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_2">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  {
    url: Path.archive,
    model_name: "Archive",
    name: "Archive",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M5 19H19V8H5V19ZM10.55 13V10H13.46V13H16L12 17L8 13H10.55Z"
          fill="black"
        />
        <path
          d="M16 13H13.45V10H10.55V13H8L12 17L16 13ZM20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM6.24 5H17.76L18.57 5.97H5.44L6.24 5ZM19 19H5V8H19V19Z"
          fill="black"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  {
    url: Path.prescriptionMail,
    model_name: "mail",
    name: "Mail",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.19667 19.0217 2.00067 18.5507 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.98 4.19667 3.45067 4.00067 4 4H20C20.55 4 21.021 4.196 21.413 4.588C21.805 4.98 22.0007 5.45067 22 6V18C22 18.55 21.8043 19.021 21.413 19.413C21.0217 19.805 20.5507 20.0007 20 20H4ZM12 13L20 8V6L12 11L4 6V8L12 13Z"
          fill="black"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: true,
    is_open: false,
    count: 0,
    sub_modules: [
      {
        url: Path.prescriptionMail,
        model_name: "prescriptionMail",
        name: "Prescription Mail",
        //   sidebar_icon: "fas fa-fire",
        sidebar_icon: (
          <svg
            width="18"
            height="24"
            viewBox="0 0 18 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_38_549)">
              <path
                d="M15.76 2.85207H13.183V4.07307H15.767C16.422 4.07307 16.953 4.60407 16.953 5.25907V21.6001C16.953 22.2561 16.421 22.7871 15.766 22.7871H2.40099C2.24512 22.7871 2.09076 22.7564 1.94675 22.6967C1.80274 22.6371 1.67188 22.5496 1.56166 22.4394C1.45144 22.3292 1.364 22.1983 1.30435 22.0543C1.2447 21.9103 1.21399 21.756 1.21399 21.6001V5.25907C1.21399 4.60307 1.74599 4.07207 2.40099 4.07207H4.98499V2.85207H2.40799C2.09134 2.85194 1.77776 2.91422 1.48519 3.03533C1.19261 3.15645 0.926775 3.33404 0.702867 3.55795C0.478958 3.78186 0.301371 4.04769 0.180253 4.34027C0.0591355 4.63284 -0.00313719 4.94642 -0.00300577 5.26307V21.5891C-0.0030058 21.9056 0.0593638 22.2191 0.18054 22.5116C0.301717 22.804 0.479325 23.0698 0.70322 23.2936C0.927115 23.5174 1.19291 23.6949 1.48542 23.8159C1.77793 23.937 2.09142 23.9992 2.40799 23.9991H15.759C16.0756 23.9992 16.3892 23.9369 16.6818 23.8158C16.9744 23.6947 17.2402 23.5171 17.4641 23.2932C17.688 23.0693 17.8656 22.8035 17.9867 22.5109C18.1079 22.2183 18.1701 21.9047 18.17 21.5881V5.26207C18.1701 4.94542 18.1079 4.63184 17.9867 4.33927C17.8656 4.04669 17.688 3.78085 17.4641 3.55695C17.2402 3.33304 16.9744 3.15545 16.6818 3.03433C16.3892 2.91322 16.0756 2.85094 15.759 2.85107L15.76 2.85207Z"
                fill="black"
              />
              <path
                d="M12.605 2.225H11.286C11.286 1.63489 11.0516 1.06896 10.6343 0.651687C10.217 0.234419 9.65111 0 9.06101 0C8.4709 0 7.90496 0.234419 7.48769 0.651687C7.07043 1.06896 6.83601 1.63489 6.83601 2.225H5.52601V5.282H12.599V2.225H12.605ZM10.347 2.225H7.77701V2.193C7.77701 1.85193 7.91249 1.52483 8.15367 1.28366C8.39484 1.04249 8.72194 0.907 9.06301 0.907C9.40407 0.907 9.73117 1.04249 9.97235 1.28366C10.2135 1.52483 10.349 1.85193 10.349 2.193V2.227V2.225H10.347ZM5.94701 8.512H15.405V9.682H5.94701V8.512ZM5.94701 13.41H15.405V14.58H5.94701V13.41ZM5.94701 18.25H15.405V19.426H5.94701V18.25ZM2.62801 7.757H5.30801V10.437H2.62801V7.757ZM2.62801 12.655H5.30801V15.335H2.62801V12.655ZM2.62801 17.497H5.30801V20.177H2.62801V17.497Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_38_549">
                <rect width="18" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        icon: "far fa fa-user",
        dashboard: false,
        is_modules: false,
        is_permission: true,
        is_sidebar: true,
        is_dropdown: false,
        is_open: false,
        count: 0,
      },
    ],
  },
  {
    url: Path.contactUs,
    model_name: "Contact Us",
    name: "Contact Us",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V7H2V9H4V11H2V13H4V15H2V17H4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM13 4.999C14.648 4.999 16 6.35 16 7.999C15.9976 8.79401 15.6808 9.5558 15.1188 10.1181C14.5567 10.6803 13.795 10.9974 13 11C11.353 11 10 9.647 10 7.999C10 6.35 11.353 4.999 13 4.999ZM19 18H7V17.25C7 15.031 9.705 12.75 13 12.75C16.295 12.75 19 15.031 19 17.25V18Z"
          fill="black"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  {
    url: Path.chatRoom,
    model_name: "Chat Room",
    name: "Chat Room",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 0C4.547 0 0 3.75 0 8.5C0 10.93 1.33 13.048 3.219 14.594C3.09605 15.4152 2.76217 16.1904 2.25 16.844C2.04089 17.1122 1.82208 17.3727 1.594 17.625C1.47603 17.7493 1.37115 17.8853 1.281 18.031C1.224 18.124 1.135 18.228 1.094 18.438C1.053 18.648 1.109 18.991 1.281 19.25L1.406 19.469L1.656 19.594C2.531 20.031 3.476 19.954 4.344 19.719C5.211 19.483 6.045 19.079 6.844 18.656C7.643 18.233 8.401 17.792 9 17.469C9.084 17.424 9.138 17.413 9.219 17.375C10.796 19.543 13.684 21 16.906 21C16.937 21.004 16.966 21 17 21C18.3 21 22.5 25.294 25 23.594C25.1 23.195 22.802 22.194 22.687 19.219C24.644 17.836 25.907 15.779 25.907 13.5C25.907 10.128 23.231 7.342 19.657 6.344C18.526 2.664 14.594 0 10 0ZM10 2C14.547 2 18 5.05 18 8.5C18 11.95 14.547 15 10 15C9.188 15 8.722 15.332 8.062 15.688C7.402 16.044 6.645 16.484 5.906 16.875C5.266 17.213 4.656 17.473 4.094 17.656C4.641 16.866 5.212 15.827 5.312 14.375L5.344 13.812L4.875 13.469C3.093 12.22 2 10.423 2 8.5C2 5.05 5.453 2 10 2Z"
          fill="black"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
  {
    url: Path.communityCategory,
    model_name: "Community Category",
    name: "Community Category",
    //   sidebar_icon: "fas fa-fire",
    sidebar_icon: (
      <svg
        width="24"
        height="20"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.234 5.73C5.95509 4.58755 6.95376 3.64631 8.13687 2.99408C9.31999 2.34185 10.649 1.99985 12 2C13.3512 1.99969 14.6804 2.3416 15.8637 2.99384C17.047 3.64608 18.0458 4.5874 18.767 5.73L20.457 4.66C19.5554 3.23247 18.307 2.05647 16.8282 1.24163C15.3494 0.426785 13.6884 -0.000363637 12 2.32278e-07C10.3118 -0.000194793 8.65093 0.427034 7.17234 1.24187C5.69375 2.0567 4.44552 3.23261 3.544 4.66L5.234 5.73ZM12 18C10.649 18.0001 9.31999 17.6582 8.13687 17.0059C6.95376 16.3537 5.95509 15.4125 5.234 14.27L3.544 15.34C4.44552 16.7674 5.69375 17.9433 7.17234 18.7581C8.65093 19.573 10.3118 20.0002 12 20C13.6884 20.0004 15.3494 19.5732 16.8282 18.7584C18.307 17.9435 19.5554 16.7675 20.457 15.34L18.767 14.27C18.0458 15.4126 17.047 16.3539 15.8637 17.0062C14.6804 17.6584 13.3512 18.0003 12 18ZM12 6C12.2652 6 12.5196 6.10536 12.7071 6.29289C12.8946 6.48043 13 6.73478 13 7C13 7.26522 12.8946 7.51957 12.7071 7.70711C12.5196 7.89464 12.2652 8 12 8C11.7348 8 11.4804 7.89464 11.2929 7.70711C11.1054 7.51957 11 7.26522 11 7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6ZM12 10C12.7956 10 13.5587 9.68393 14.1213 9.12132C14.6839 8.55871 15 7.79565 15 7C15 6.20435 14.6839 5.44129 14.1213 4.87868C13.5587 4.31607 12.7956 4 12 4C11.2044 4 10.4413 4.31607 9.87868 4.87868C9.31607 5.44129 9 6.20435 9 7C9 7.79565 9.31607 8.55871 9.87868 9.12132C10.4413 9.68393 11.2044 10 12 10ZM12 13C11.4696 13 10.9609 13.2107 10.5858 13.5858C10.2107 13.9609 10 14.4696 10 15H8C8 13.9391 8.42143 12.9217 9.17157 12.1716C9.92172 11.4214 10.9391 11 12 11C13.0609 11 14.0783 11.4214 14.8284 12.1716C15.5786 12.9217 16 13.9391 16 15H14C14 14.4696 13.7893 13.9609 13.4142 13.5858C13.0391 13.2107 12.5304 13 12 13ZM3 9C2.73478 9 2.48043 9.10536 2.29289 9.29289C2.10536 9.48043 2 9.73478 2 10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11C3.26522 11 3.51957 10.8946 3.70711 10.7071C3.89464 10.5196 4 10.2652 4 10C4 9.73478 3.89464 9.48043 3.70711 9.29289C3.51957 9.10536 3.26522 9 3 9ZM0 10C0 9.20435 0.31607 8.44129 0.87868 7.87868C1.44129 7.31607 2.20435 7 3 7C3.79565 7 4.55871 7.31607 5.12132 7.87868C5.68393 8.44129 6 9.20435 6 10C6 10.7956 5.68393 11.5587 5.12132 12.1213C4.55871 12.6839 3.79565 13 3 13C2.20435 13 1.44129 12.6839 0.87868 12.1213C0.31607 11.5587 0 10.7956 0 10ZM20 10C20 9.73478 20.1054 9.48043 20.2929 9.29289C20.4804 9.10536 20.7348 9 21 9C21.2652 9 21.5196 9.10536 21.7071 9.29289C21.8946 9.48043 22 9.73478 22 10C22 10.2652 21.8946 10.5196 21.7071 10.7071C21.5196 10.8946 21.2652 11 21 11C20.7348 11 20.4804 10.8946 20.2929 10.7071C20.1054 10.5196 20 10.2652 20 10ZM21 7C20.2044 7 19.4413 7.31607 18.8787 7.87868C18.3161 8.44129 18 9.20435 18 10C18 10.7956 18.3161 11.5587 18.8787 12.1213C19.4413 12.6839 20.2044 13 21 13C21.7956 13 22.5587 12.6839 23.1213 12.1213C23.6839 11.5587 24 10.7956 24 10C24 9.20435 23.6839 8.44129 23.1213 7.87868C22.5587 7.31607 21.7956 7 21 7Z"
          fill="black"
        />
      </svg>
    ),
    icon: "far fa fa-user",
    dashboard: false,
    is_modules: false,
    is_permission: true,
    is_sidebar: true,
    is_dropdown: false,
    is_open: false,
    count: 0,
    sub_modules: {},
  },
];
